var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profileIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.001,
    viewBox: "0 0 24 24.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-person",
    "data-name": "Icon ionic-ios-person",
    d: "M28.489,27.895c-.45-1.988-3.019-2.956-3.906-3.269A29.125,29.125,0,0,0,21.326,24a3.309,3.309,0,0,1-1.506-.694,13.165,13.165,0,0,1-.1-3.081,9.271,9.271,0,0,0,.713-1.356,17.5,17.5,0,0,0,.525-2.369s.513,0,.694-.9a8.855,8.855,0,0,0,.463-2.094c-.038-.719-.431-.7-.431-.7A10.959,10.959,0,0,0,22.107,9.6c.056-2.569-1.956-5.1-5.6-5.1-3.694,0-5.663,2.531-5.607,5.1a11.431,11.431,0,0,0,.419,3.206s-.394-.019-.431.7A8.855,8.855,0,0,0,11.35,15.6c.175.9.694.9.694.9a17.5,17.5,0,0,0,.525,2.369,9.271,9.271,0,0,0,.713,1.356,13.165,13.165,0,0,1-.1,3.081A3.309,3.309,0,0,1,11.675,24a29.125,29.125,0,0,0-3.256.625c-.888.313-3.456,1.281-3.906,3.269a.5.5,0,0,0,.494.606H28A.5.5,0,0,0,28.489,27.895Z",
    transform: "translate(-4.501 -4.5)",
    fill: "#414042"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.14981bba98809f179d30d3fd14d9bbf0.svg";
export { ForwardRef as ReactComponent };